import { Icon } from "./Icon";
import { t } from "../i18n";

export const AvailableAppointments = ({
	appointments,
	loading,
	centerCode,
	selectCenter,
	infoCenter,
	viewMap,
	onViewMore,
	onSelectAppointment,
}) => {

	return (
		viewMap === null && (
			<>
				{appointments?.length > 0 ? (
					<div className="available_appointments">
						<div className="appointments_container">
							<p className="appointments_title">
								{t("Citas disponibles")}
							</p>
							<ul className="appointments_list">
								{appointments.map((apt, idx) => (
									<li
										key={idx}
										className="appointment_item"
										onPointerDown={(e) => e.stopPropagation()}
										onClick={() =>
											onSelectAppointment &&
											onSelectAppointment(apt, centerCode)
										}
									>
										<span className="appointment_date">
											{apt.date}
										</span>
										<span className="appointment_time">
											{apt.time}
										</span>
									</li>
								))}
							</ul>
							<div
								className="available_more"
								onClick={() => onViewMore && onViewMore(centerCode)}
							>
								<Icon name="calendar" />
								<span>{t("Ver más horarios")}</span>
							</div>
						</div>
					</div>
				) : (
					!loading && (
						<button
							className="center_cta"
							onPointerDown={(e) => {
								e.stopPropagation();
								selectCenter(infoCenter)();
							}}
						>
							Seleccionar taller
							<Icon name="arrow" />
						</button>
					)
				)}
				{loading && <div className="spinner" style={{ width: 24, height: 24 }}></div>}
			</>
		)
	);
};
